"use client";

import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

interface PasswordToggleProps {
  value?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
  label?: string;
  name?: string;
  id?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
}

const PasswordToggle: React.FC<PasswordToggleProps> = ({
  value,
  placeholder = "Contraseña",
  required = false,
  className = "",
  name,
  id,
  disabled,
  onChange,
  onBlur,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const defaultClassName =
    "w-full pl-14 pr-14 py-2.5 sm:pl-16 dark:bg-white sm:pr-16 sm:py-3 border border-gray-300 rounded-2xl text-sm sm:text-base bg-white focus:outline-none focus:ring-2 focus:ring-[var(--color-primary-light)] transition duration-300 text-gray-600";

  return (
    <div className="relative">
      <input
        type={showPassword ? "text" : "password"}
        placeholder={placeholder}
        required={required}
        className={className || defaultClassName}
        value={value}
        name={name}
        id={id}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
      />

      {/* Botón para mostrar/ocultar contraseña */}
      <button
        type="button"
        onClick={togglePasswordVisibility}
        disabled={disabled}
        className="absolute right-4 top-[50%] -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200 focus:outline-none focus:text-[var(--color-primary)]"
        aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
      >
        {showPassword ? (
          <FaEyeSlash className="w-6 h-6" />
        ) : (
          <FaEye className="w-6 h-6" />
        )}
      </button>
    </div>
  );
};

export default PasswordToggle;
